//jacques-andre-editeur\proshop-v2\frontend\src\screens\admin\BooksCollectionAddScreen.jsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import { useCreateBooksCollectionMutation } from '../../slices/booksCollectionsApiSlice';
import "react-quill/dist/quill.snow.css";

const BooksCollectionAddScreen = () => {
    
  const [name, setName] = useState('');
  const [intention, setIntention] = useState('');
  const [isVisible, setIsVisible] = useState(true);
  const [inList, setInList] = useState(true);

  const navigate = useNavigate();

  const [createBooksCollection, { isLoading: loadingCreate }] = useCreateBooksCollectionMutation();

  const submitHandler = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('name', name);
    formData.append('intention', intention);
    formData.append('isVisible', isVisible);
    formData.append('inList', inList);

    try {
      await createBooksCollection(formData).unwrap();
      toast.success('Collection ajouté avec succès');
      navigate('/admin/bookscollectionlist');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <Container>
      <FormContainer>
        <div className="h1-adminContainer">
          <h1>Ajouter une collection</h1>
        </div>
        {loadingCreate && <Loader />}
        <Form onSubmit={submitHandler}>

          <Form.Group controlId='name'>
            <Form.Label>Nom de la collection</Form.Label>
            <Form.Control
              type='text'
              placeholder='Saisir le nom'
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId='intention'>
            <Form.Label>Intention</Form.Label>
            <ReactQuill value={intention} onChange={setIntention} placeholder="Saisir l'intention" />
          </Form.Group>

          <Form.Group controlId='isVisible'>
            <Form.Label>Visibilité</Form.Label>
            <Form.Check
              type='checkbox'
              label='Visible'
              checked={isVisible}
              onChange={(e) => setIsVisible(e.target.checked)}
            ></Form.Check>
            <Form.Check
              type='checkbox'
              label='Présent dans la liste'
              checked={inList}
              onChange={(e) => setInList(e.target.checked)}
            ></Form.Check>
          </Form.Group>

          <Button type='submit' variant='primary' style={{ marginTop: '1rem' }}>
            Ajouter
          </Button>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default BooksCollectionAddScreen;
